import { useEffect, type ReactNode } from 'react';
import { applyUiToDom, useUiStore } from '@/stores/ui-store';

/**
 * Keeps <html>'s `lang`, `dir`, theme class, and density in sync with the
 * UI store. Subscribes once and re-applies on any change — so language /
 * theme toggles propagate through CSS custom properties immediately.
 */
export function UiProvider({ children }: { children: ReactNode }) {
  const state = useUiStore();

  useEffect(() => {
    applyUiToDom(state);
  }, [state]);

  useEffect(() => {
    if (state.theme !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => applyUiToDom(useUiStore.getState());
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [state.theme]);

  return <>{children}</>;
}
